import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

export const RTFOSettingsHistory = ({ currentRTFO }) => {

  return (
    <div style={{marginTop: 30, marginBottom: 20}}>
      <Typography color='textSecondary'>SETTINGS CHANGE HISTORY</Typography>


      <div style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
        <div style={{width: 900}}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell align="left">Date</TableCell>
                  <TableCell align="right">Parameter</TableCell>
                  <TableCell align="right">Old Value</TableCell>
                  <TableCell align="right">New Value</TableCell>
                  <TableCell align="right">Changed By</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(currentRTFO?.changeHistory || [])?.map((row, i) => (
                  <TableRow
                    key={i}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell align="left">{row.date}</TableCell>
                    <TableCell align="right">{getParameterName(row.parameter)}</TableCell>
                    <TableCell align="right">{row.oldValue}</TableCell>
                    <TableCell align="right">{row.newValue}</TableCell>
                    <TableCell align="right">{row.changedBy}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </div>  
      </div>  
    </div>
  );
};

function getParameterName(parameter) {
  switch(parameter) {
    case 'youngModulus':
      return "Young's Modulus";
    case 'fracWidth':
      return "Frac Width";
    case 't':
      return "Tranverse Exponent";
    case 'fracHeight':
      return "Frac Height";
    case 'fracAngle':
      return "Frac Orientation";
    case 'shadowRadius':
      return "Shadow Radius";
    case 'k':
      return "Matrix Permeability";
    case 'phi':
      return "Matrix Porosity";
    case 'cT':
      return "Total Compressiblity";
    case 'muW':
      return "Water Viscosity";
    case 'bW':
      return "Water FVF";
    default:
      return parameter;
  };
};